import {Component, inject} from '@angular/core';
import {
  AbstractObjectDetailService,
  DocumentFileDetailService,
  FILE_MARK_UNAVAILABLE,
  FileDetailService,
} from '|shared';
import {FileDto} from '|api/document';
import {TranslateService} from '@ngx-translate/core';
import {LoadingIndicatorService, WaitingDirective} from '@icz/angular-essentials';
import {EsslObjectDetailComponent} from '../document-shared/components/essl-object-detail/essl-object-detail.component';
import {IczFormDirective} from '@icz/angular-form-elements';
import {FileDetailToolbarComponent} from './components/file-detail-toolbar/file-detail-toolbar.component';
import {RouterOutlet} from '@angular/router';
import {AsyncPipe} from '@angular/common';
import {ApplicationRoute, DocumentsRoute} from '|ui-essl-core';
import {FileDetailRoute} from './enums/file-detail-routes.enum';


@Component({
  selector: 'icz-file-detail',
  templateUrl: './file-detail.component.html',
  styleUrls: ['./file-detail.component.scss'],
  providers: [
    FileDetailService,
    {
      provide: AbstractObjectDetailService,
      useExisting: FileDetailService,
    },
    {
      provide: DocumentFileDetailService,
      useExisting: FileDetailService,
    }
  ],
  hostDirectives: [IczFormDirective],
  imports: [EsslObjectDetailComponent, WaitingDirective, FileDetailToolbarComponent, RouterOutlet, AsyncPipe]
})
export class FileDetailComponent {

  protected translateService = inject(TranslateService);
  protected fileDetailService = inject(FileDetailService);
  protected loadingService = inject(LoadingIndicatorService);

  fileNameGeneratorFn = (file: FileDto) => (
    [`${file.refNumber ?? this.translateService.instant(FILE_MARK_UNAVAILABLE)}`, '-', file.subject!]
  );

  baseUrlPrefixParts = [ApplicationRoute.DOCUMENTS, DocumentsRoute.FILE];

  protected readonly FileDetailRoute = FileDetailRoute;
}
